import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export const useUtmTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const utm_data: Record<string, string> = {};
    let foundUtm = false;

    UTM_PARAMS.forEach(param => {
      const value = searchParams.get(param);

      if (value) {
        utm_data[param] = value;
        foundUtm = true;
      }
    });

    if (foundUtm && !sessionStorage.getItem('utm_data')) {
      sessionStorage.setItem('utm_data', JSON.stringify(utm_data));
    }
  }, [location.search]);
};
